import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Komponen untuk melindungi rute admin
 * Hanya pengguna dengan role admin yang dapat mengakses rute ini
 */
const AdminRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  
  // Cek apakah user sudah login dan memiliki role admin
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Cek role user
  if (user?.role !== 'admin') {
    console.log('Access denied: User is not admin');
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default AdminRoute;
